<style scoped>
    .vs-table--tbody-table .tr-values td {
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>
<template>
    <div>
        <vs-card class="p-4 mb-0">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">{{ $route.meta.type == 'Production Order' ? 'Production' : 'Unpack' }} Details</h4>
                </div>
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
            </div>
            <div class="vx-row mt-5">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Production Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.production_date"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Release Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.release_date"/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Status*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.status" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Client ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.client_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, client)"
                            >
                                <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Warehouse ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.warehouse_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, warehouse)"
                            >
                                <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                            </vs-select>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details" class="pt-base">
                    <vs-button class="mr-4" type="border" @click="addDetail()" :disabled="!data.client_id">Add</vs-button>
                    <vs-button type="border" :disabled="details_selected.length < 1">Remove</vs-button>
                    <vs-table hoverFlat :data="details" v-model="details_selected" class="mt-base" multiple>
                        <template slot="thead">
                            <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                            <vs-th style="min-width: 200px;">Product ID</vs-th>
                            <vs-th style="min-width: 200px;">Description</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Stock Type</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>
                                    <vs-input class="w-full" :value="indextr + 1" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.product_id"
                                        width="100%"
                                        autocomplete
                                        @change="productChange(tr)"
                                    >
                                        <vs-select-item v-for="(item, index) in products" :key="index" :value="item.id" :text="item.product_code"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.pack_id" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.batch" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <flat-pickr class="w-full" v-model="tr.expired_date" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.qty" @input="qtyChange(tr)" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.uom_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="!tr.product_id"
                                        @change="qtyChange(tr)"
                                    >
                                        <vs-select-item v-for="(item, index) in tr.uoms" :key="index" :value="item.uom.id" :text="item.uom.name"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.stock_type_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="!tr.product_id"
                                    >
                                        <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.base_qty" disabled/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.base_uom" disabled/>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
                <vs-tab label="Components" class="pt-base">
                    <vs-button class="mr-4" type="border" :disabled="details.length < 1" @click="reloadComponent">Reload</vs-button>
                    <vs-button class="mr-4" type="border" :disabled="details.length < 1" @click="add('component')">Add</vs-button>
                    <vs-button type="border" :disabled="components_selected.length < 1">Remove</vs-button>
                    <vs-table v-model="components_selected" :data="components" hoverFlat class="mt-base" multiple>
                        <template slot="thead">
                            <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                            <vs-th style="min-width: 70px; width: 70px">Main</vs-th>
                            <vs-th style="min-width: 200px;">Product ID</vs-th>
                            <vs-th style="min-width: 200px;">Description</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Stock Type</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>
                                    <vs-input class="w-full" :value="indextr + 1" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-checkbox class="w-full" disabled v-model="tr.main"></vs-checkbox>
                                </vs-td>
                                <vs-td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.product_id"
                                            width="100%"
                                            autocomplete
                                            :disabled="tr.main"
                                            @change="productChange(tr)"
                                        >
                                            <vs-select-item v-for="(item, index) in products" :key="index" :value="item.id" :text="item.product_code"/>
                                        </vs-select>
                                    </td>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.pack_id" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.batch" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <flat-pickr class="w-full" v-model="tr.expired_date" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.qty" @input="qtyChange(tr)" :disabled="!tr.product_id || tr.main"/>
                                </vs-td>
                                <vs-td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.uom_id"
                                            width="100%"
                                            autocomplete
                                            @change="qtyChange(tr)"
                                            :disabled="tr.main || !tr.product_id"
                                        >
                                            <vs-select-item v-for="(item, index) in tr.uoms" :key="index" :value="item.uom.id" :text="item.uom.name"/>
                                        </vs-select>
                                    </td>
                                </vs-td>
                                <vs-td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.stock_type_id"
                                            width="100%"
                                            autocomplete
                                            :disabled="tr.main || !tr.product_id"
                                        >
                                            <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </td>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.base_qty" disabled/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.base_uom" disabled/>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
            </vs-tabs>
        </vs-card>
    </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: {
                client_id: this.getUserDefault('client_id'),
                warehouse_id: this.getUserDefault('warehouse_id')
            },
            details: [],
            details_selected: [],
            components: [],
            components_selected: [],
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            stock_type: {
                data: [],
                loading: false,
                endpoint: 'master/stocktypes',
                objectKey: 'name'
            },
            products: []
        }
    },
    watch: {
        isLoading: function() {
            if(this.isLoading) {
                this.$vs.loading();
            }
            else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.$router.push({
                name: this.$route.meta.slug
            });
        },
        fetchData() {
            this.isLoading = true;
            Promise.all([
                this.$http.post('master/clients'),
                this.$http.post('master/warehouses'),
                this.$http.post('master/stocktypes')
            ])
            .then(this.$http.spread((clients, warehouses, stock_types) => {
                this.client.data = clients.data.data;
                this.warehouse.data = warehouses.data.data;
                this.stock_type.data = stock_types.data.data;
                this.isLoading = false;
            }))
            .catch(error => this.handleError(error));
        },
        add(type = 'detail') {
            let dest = this.details;

            if(type == 'component') {
                dest = this.components;
            }

            dest.push({
                main: false,
                product_id: null,
                description: '',
                pack_id: '',
                batch: '',
                expired_date: '',
                qty: '',
                uom_id: null,
                stock_type_id: this.getUserDefault('stock_type_id'),
                base_qty: '',
                base_uom: '',
                uoms: []
            });
        },
        addDetail(type = 'detail') {
            if(!this.data.client_id) {
                return false;
            }

            if(!this.products.length) {
                this.isLoading = true;
                this.$http.post('master/product', { client_id: this.data.client_id })
                .then(res => {
                    this.products = res.data.data;
                    this.add();
                    this.isLoading = false;
                })
                .catch(error => this.handleError(error))
            }
            else {
                this.add();
            }
        },
        reloadComponent() {
            this.isLoading = true;
            
            const data = this.details.map(i => {
                return {
                    product_id: i.product_id,
                    qty: i.qty,
                    uom_id: i.uom_id
                }
            });

            this.$http.post('valueaddedservice/getcomponents', { data: data })
            .then(res => {
                this.components = [];
                res.data.map(i => {
                    if(this.products.findIndex(p => p.id === i.id) === -1) {
                        this.products.push(i);
                    }

                    this.components.push({
                        main: i.main,
                        product_id: i.id,
                        description: i.description,
                        pack_id: '',
                        batch: '',
                        expired_date: '',
                        qty: i.qty,
                        uom_id: i.uom_id,
                        stock_type_id: 1,
                        base_qty: i.base_qty,
                        base_uom: i.base_uom.uom.name,
                        uoms: i.uoms
                    });
                });

                this.isLoading = false;
            })
            .catch(error => this.handleError(error))
        },
        productChange(data) {
            const product = this.products[this.products.findIndex(p => p.id == data.product_id)];
            
            if(product) {
                data.description = product.description_1;
                data.uoms = product.uoms;
                data.base_uom = product.base_uom.uom.name;
                data.uom_id = product.base_uom.uom.id;
            }
        },
        qtyChange(tr) {
            const uom = tr.uoms[tr.uoms.findIndex(d => d.uom_id == tr.uom_id)];

            if(uom) {
                tr.base_qty = (tr.qty / uom.denominator) * uom.numerator;
            }
        },
        submitForm() {
            this.isLoading = true;

            const data = this.data;
            data.type = this.$route.meta.type;
            data.details = this.details.map(item => {
                return {
                    product_id: item.product_id,
                    qty: item.qty,
                    uom_id: item.uom_id,
                    pack_id: item.pack_id,
                    batch: item.batch,
                    expired_date: item.expired_date,
                    stock_type_id: item.stock_type_id
                }
            });
            data.components = this.components.map(item => {
                return {
                    product_id: item.product_id,
                    main: item.main,
                    qty: item.qty,
                    uom_id: item.uom_id,
                    pack_id: item.pack_id,
                    batch: item.batch,
                    expired_date: item.expired_date,
                    stock_type_id: item.stock_type_id
                }
            });

            this.$http.post('valueaddedservice/store', data)
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'Saved successfully'
                })

                this.$router.push({
                    name: 'production-order-view',
                    params: {
                        id: res.data.id
                    }
                });
            })
            .catch(error => this.handleError(error));
        }
    },
    mounted() {
        this.fetchData();
    }
};
</script>